import type { summaryResource } from '@porotutu/api/features/crm/dashboard/resource'
import { unwrap } from '@porotutu/react/api'
import { queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { DASHBOARD } from '@/api/keys'

export type Summary = ReturnType<typeof summaryResource>

export type OrderWeek = Summary['order_trend'][number]

export const summaryQuery = () =>
  queryOptions({
    queryKey: [...DASHBOARD, 'summary'] as const,
    queryFn: async () => unwrap(await crm.dashboard.get()),
    staleTime: 60_000,
  })
